import { useEffect, useMemo, useState } from "react";
import { useFormCombos } from "./useFormCombos";
import { useTranslation } from "react-i18next";
import { getSlotById } from "../services/slots.service";
import { ISlotCommitteeDetails } from "../types/slotCommitteeDetails";
import { getById } from "../services/minutes.service";
import { MinuteSlot } from "../types/minuteSlot";

interface GetSlotByIdResponse {
  data: ISlotCommitteeDetails | null;
  error: any;
}

type StatusMaterialItem = {
  id: number;
  name: string;
};

const useSlotCommitteeDetails = (slotId: string, slotCommitteeId: string) => {
  const { i18n } = useTranslation();
  const [slotCommitteeInformations, setSlotCommitteeInformations] =
    useState<ISlotCommitteeDetails | null>(null);
  const { statusMaterial, getStatusMaterial } = useFormCombos();
  const [minuteSlot, setMinuteSlot] = useState<MinuteSlot | null>();

  useEffect(() => {
    let slotCommitteeInfo: ISlotCommitteeDetails | null;
    let minuteSlotInfo: MinuteSlot;

    getSlotById(slotId, slotCommitteeId)
      .then(async (slotInformations: GetSlotByIdResponse) => {
        slotCommitteeInfo = slotInformations.data;

        const minuteSlotId = slotCommitteeInfo?.minuteSlotId;
        if (minuteSlotId) {
          minuteSlotInfo = (await getById(
            slotCommitteeInfo?.minuteSlotId
          )) as MinuteSlot;
        }
      })
      .catch(() => {
        console.error("Erro ao buscar slot info");
      })
      .finally(() => {
        setMinuteSlot(minuteSlotInfo);
        setSlotCommitteeInformations(slotCommitteeInfo);
      });

    if (i18n.language) {
      getStatusMaterial(i18n.language);
    }
  }, []);

  const materialStatus = useMemo(() => {
    const materialStatus = statusMaterial.find(
      (s: StatusMaterialItem) =>
        s.id === Number(slotCommitteeInformations?.materialSupportStatus)
    );

    // @ts-ignore
    return materialStatus?.name;
  }, [slotCommitteeInformations]);

  return { slotCommitteeInformations, materialStatus, minuteSlot };
};

export { useSlotCommitteeDetails };
